import useDefaultInputStyles from "../../hooks/useDefaultInputStyles";
import MultiSelectMenu from "./MultiSelectMenu";
import { useState } from "react";

let currentMenuStateFn = undefined;

function MultiSelect({
  className,
  title,
  hasSearch = true,
  items = [],
  name,
  setValue,
  getValues,
  watch,
  classes = {},
  ...props
}) {
  props = useDefaultInputStyles(props);

  let [closeState, setCloseState] = useState(true);

  function handleClick(evt) {
    if (currentMenuStateFn) {
      currentMenuStateFn(true);
    }

    setCloseState((curent) => {
      return !curent;
    });

    currentMenuStateFn = setCloseState;
  }

  return (
    <div>
      <div {...props} className={className} onClick={handleClick}>
        {title}
        <img
          src="/calendar/arrow.svg"
          className={`${
            "multiSelect_arrow " +
            (!closeState ? "multiSelect_arrow-opened" : "")
          } ${classes.image || ""}`}
        />
      </div>
      <MultiSelectMenu
        closeState={closeState}
        setCloseState={setCloseState}
        hasSearch={hasSearch}
        title={title}
        name={name}
        items={items}
        setValue={setValue}
        getValues={getValues}
        watch={watch}
      ></MultiSelectMenu>
    </div>
  );
}

export default MultiSelect;
